<p-table [value]="this.widgets" styleClass="Table" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th [width]="'30%'">{{ "COMMON.NAME" | translate }}</th>
      <th>{{ "COMMON.DESCRIPTION" | translate }}</th>
      <th [width]="'10%'">{{ "COMMON.ACTIVE" | translate }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-widget>
    <tr>
      <td [width]="'30%'">
        {{ "WIDGETS." + widget.code + ".TITLE" | translate }}
      </td>
      <td>{{ "WIDGETS." + widget.code + ".DESCRIPTION" | translate }}</td>
      <td [width]="'10%'">
        <p-inputSwitch
          (onChange)="this.updateWidget($event, widget)"
          [(ngModel)]="this.roleHasWidget[widget.code]"
        >
        </p-inputSwitch>
      </td>
    </tr>
  </ng-template>
</p-table>
